(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/prescript.js'); svs.sportsbook = svs.sportsbook || {};

svs.sportsbook.data = svs.sportsbook.data || {};

svs.sportsbook.sbtech_api_impl = svs.sportsbook.sbtech_api_impl || {};
svs.sportsbook.sbtech_api_impl.services = {};
svs.sportsbook.sbtech_api_impl.utils = {};
svs.sportsbook.sbtech_api_impl.fns = {
  actions: {},
  requests: {}
};

svs.sportsbook.sbtech_api_impl.styleClasses = {
  BETSLIP: 'sportsbook-betslip',
  BETSLIP_ADD_ITEM: 'sportsbook-betslip--items-count-add',
  BETSLIP_OPEN: 'sportsbook-betslip--is-open',
  YOURBET: 'sb__your_bet',
  YOURBET_SELECTION_CHANGED: 'sb__your_bet__selection--updated',
  YOURBET_OPEN: 'sb__your_bet--is-open',
  INVALID: 'sb__your_bet--invalid'
};

svs.sportsbook.sbtech_api_impl.constants = {
  TABLET: 'IsTablet',
  DESKTOP: 'IsDesktop',
  MOBILE: 'IsMobile',
  UNKNOWN: 'IsUnknown'
};

svs.sportsbook.sbtech_api_impl.deviceTypeMode = svs.sportsbook.sbtech_api_impl.constants.UNKNOWN;

svs.sportsbook.sbtech_api_impl.logger = svs.core.log.getLogger('sbtech-script-impl');

 })(window);